import { WHITEBIT_WS_CHANNELS, WHITEBIT_WS_TOPOLOGY } from './ws';

import type { ExchangeId } from '../../lib/types';

export const WHITEBIT_METADATA = {
  id: 'whitebit' as ExchangeId,
  restDocs: [
    'https://docs.whitebit.com/public/http-v4/',
    'https://docs.whitebit.com/public/http-v1/',
  ],
  wsDocs: [
    'https://docs.whitebit.com/public/websocket/',
    'https://docs.whitebit.com/public/websocket/#market-depth',
    'https://docs.whitebit.com/public/websocket/#kline',
  ],
  wsTopology: WHITEBIT_WS_TOPOLOGY,
  wsChannels: WHITEBIT_WS_CHANNELS,
  notes: [
    'JSON-RPC protocol with plain JSON (no compression).',
    'Client-initiated ping every 50 seconds.',
    'Incremental orderbook with update_id sequence tracking.',
    'Symbol format: uppercase underscore (BTC_USDT).',
    'Kline timestamps are in SECONDS (must multiply by 1000).',
    'Kline format: [time, open, close, high, low, volumeStock, volumeMoney] - not typical OHLC order.',
  ],
} as const;
